import { render } from "./AddGpsReportForTraining.vue?vue&type=template&id=6f24b7ff&scoped=true"
import script from "./AddGpsReportForTraining.vue?vue&type=script&lang=js"
export * from "./AddGpsReportForTraining.vue?vue&type=script&lang=js"

import "./AddGpsReportForTraining.vue?vue&type=style&index=0&id=6f24b7ff&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f24b7ff"]])

export default __exports__